import { Container } from 'bitmovin-player-ui';
import { createWatchFromStartButton, createGoBackLiveButton } from './buttons';
export function createCTABar(player) {
    const goBackLiveButton = createGoBackLiveButton(player);
    const watchFromStartButton = createWatchFromStartButton();
    return new Container({
        components: [watchFromStartButton, goBackLiveButton],
        cssClasses: ['controlbar-textbuttons']
    });
}
